import { User } from '../store/dbTypes'
import { fbSetup } from '../common/fbFunctions'
import { sendMessageToMark } from '../Messages/messages.model'
import { mobileVendor, mobileModel } from 'react-device-detect'

export const storeFbPushNotificationSubscription = async (
  user: User,
  subscription: PushSubscription
) => {
  const { fbStorePushSubscription } = await fbSetup()

  try {
    const response = await fbStorePushSubscription({
      environment: import.meta.env.VITE_ENVIRONMENT,
      userId: user.userId,
      userFullName: `${user.fullName} [${mobileVendor} ${mobileModel}]`,
      subscription: JSON.stringify(subscription),
    })
    return true
  } catch (error) {
    console.error('Error storing push notification subscription:', error)
    return false
  }
}

export const removeFbPushNotificationSubscription = async (
  user: User,
  subscription: PushSubscription
) => {
  const { fbRemovePushSubscription } = await fbSetup()

  try {
    const response = await fbRemovePushSubscription({
      environment: import.meta.env.VITE_ENVIRONMENT,
      userId: user.userId,
      subscription: JSON.stringify(subscription),
    })
    return true
  } catch (error) {
    console.error('Error removing push notification subscription:', error)
    return false
  }
}

// Send a single push notification to a user
export const sendFbPushNotification = async (
  toUser: User,
  title: string,
  message: string
) => {
  const { fbSendPushNotification } = await fbSetup()
  try {
    const response = await fbSendPushNotification({
      environment: import.meta.env.VITE_ENVIRONMENT,
      toUserId: toUser.userId,
      toUserFullName: toUser.fullName,
      title: title,
      message: message,
    })
    if (response.data.isSuccess) return true

    // Let me know the names of the users that failed to receive the push notification
    await sendMessageToMark(
      `Failed Push Notification to: ${toUser.fullName} with error: ${response.data.message}`
    )
    return false
  } catch (error) {
    console.error('Error sending push notification:', error)
    return false
  }

  return true
}
